import { SalesOrganizationContract } from '../sales-organizations/types';

export interface SegmentGroupContract {
  id: string;
  salesOrganization: SalesOrganizationContract;
  priority: Priority;
}

export interface SegmentContract {
  id: string;
  name: string;
  priority: Priority;
}

export interface UpdateSegmentContract {
  name: string;
  priority: Priority;
}

export interface SegmentUsageContract {
  name: string;
  accountCount: number;
  totalTargetVisitsPerYear: number;
}

export enum Priority {
  HIGH = 'High',
  MEDIUM = 'Medium',
  NO_PRIORITY = 'No Priority',
}

export const priorityToColorMap: {
  [key in Priority]: { color: string; background: string; border: string };
} = {
  [Priority.HIGH]: {
    color: '#ba8ad7',
    background: '#1a2638',
    border: '#47365f',
  },
  [Priority.MEDIUM]: {
    color: '#6aa2c3',
    background: '#182c3d',
    border: '#30526b',
  },
  [Priority.NO_PRIORITY]: {
    color: '#9fa5ad',
    background: '#0e1f31',
    border: '#374a5c',
  },
};
